/**
 *
 * Asynchronously loads the component for Subscription
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const Subscription = lazyLoad(
  () => import('./index'),
  module => module.Subscription,
);
